import { RulaSegmentAdapter } from '@pathccm/browser-analytics/segment'
import { ProductArea, UserType } from '@pathccm/common-analytics/events'
import CookieManager from '../utils/cookie-manager'

export const segment = new RulaSegmentAdapter({
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  apiKey: process.env.GATSBY_SEGMENT_API_KEY!,
  productArea: ProductArea.MARKETING_SITE,
  userType: UserType.PATIENT
})

const cookieManager = new CookieManager()
segment
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  .enableAmplitudeSessionReplay(process.env.GATSBY_AMPLITUDE_API_KEY!, cookieManager)
  .catch((err) => {
    console.error('enableAmplitudeSessionReplay error: ', err)
  })
